import { FC } from 'react';
import EfSpec from '@elem/ui/ef-spec';
import EfImg from '@elem/ui/ef-img';
import { useProductStore } from '@elem/compPage/CES2025/ProductProvider';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

type ItemType = {
    label: string;
    text: string;
};

const D: FC = () => {
    const { t } = useLang('ces2025');
    const { pageStatus } = useProductStore();
    const items: ItemType[] = [
        {
            label: t('D_item1_label'),
            text: t('D_item1_text'),
        },
        {
            label: t('D_item2_label'),
            text: t('D_item2_text'),
        },
    ];

    return (
        <section className={styles.section} id="CES-2025-D">
            <EfSpec />
            <p className="sec-title">{t('D_title')}</p>
            <div className="box">
                <div className="left">
                    <EfImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1733370478710/C_PC.png"
                        h5="https://websiteoss.ecoflow.com/upload/image/1733370478547/C_M.png"
                        className="ces-map-pic"
                    />
                </div>
                <div className="right">
                    <div className="inner">
                        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="51" viewBox="0 0 50 51" fill="none">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M25 48C12.55 48 2.5 37.95 2.5 25.5C2.5 13.05 12.55 3 25 3C37.45 3 47.5 13.05 47.5 25.5C47.5 37.95 37.45 48 25 48ZM24.5 36.8C24.55 36.85 24.75 36.9 25 36.9C25.3 36.85 25.45 36.8 25.5 36.75C25.55 36.7 31 30 32.8 26.55C33.5 25.35 33.75 24.25 33.75 22.8C33.75 18 29.75 14.1 24.95 14.1C20.15 14.1 16.2 18 16.2 22.75C16.2 24 16.55 25.3 17.1 26.5C18.3899 29.3378 22.8966 34.8377 24.1655 36.3864C24.3722 36.6386 24.493 36.786 24.5 36.8ZM21.1 22.85C21.1 20.7 22.9 18.95 25 18.95C27.1 18.95 28.9 20.6 28.9 22.85C28.9 25 27.15 26.75 25 26.75C22.85 26.75 21.1 25 21.1 22.85Z"
                                fill="#F7A40A"
                            />
                        </svg>
                        <ul className="items">
                            {items.map((item: ItemType, k: number) => (
                                <li key={k} className="item">
                                    <p className="item-label">{item.label}</p>
                                    <p className="item-text">{item.text}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default D;
